import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  padding-right: 0.5rem;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`

export const SectionTitle = styled.h2`
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #999;
`

export const SectionElements = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 0.6rem;
  box-sizing: border-box;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  margin: 0;
  padding: 0;
  color: inherit;
`

export const IconWrapper = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 0.4rem;
  background-color: #E6F4FB;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const SectionElement = styled.li`
  background-color: #fff;
  padding: 0.75rem;
  border-radius: 0.75rem;
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;

  &:hover {
    background-color: #f8f9fa;
  }
`

export const ElementName = styled.h2`
  font-weight: 600;
  font-size: 0.8rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ElementImage = styled.img`
  width: 1.2rem;
  height: 1.2rem;
  object-fit: contain;
  flex-shrink: 0;

  &.arrow {
    position: absolute;
    right: 0.75rem;
    width: 0.5rem;
    height: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
  }
`
